import { render, staticRenderFns } from "./RestrictWhatsappDate.vue?vue&type=template&id=2e7c7d49"
import script from "./RestrictWhatsappDate.vue?vue&type=script&lang=js"
export * from "./RestrictWhatsappDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports